/**
 * Leaders 1032 — BDU "Our Leadership"
 * Heading with a gradient rule, a scrollable rail of bordered portrait cards, and
 * round prev/next buttons that appear only below the desktop breakpoint.
 */

export const LEADERS_1032_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Leaders",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_name: "",
    meta_designation: "",
    meta_priority: 1,
    meta_status: true,
  },

  LEADERS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Our Leadership",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Our Leadership",
    },
    {
      fieldName: "title_start_color",
      label: "Heading colour",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#000000",
    },
    {
      fieldName: "desktop_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading — start",
      value: "#1F3D56",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#1F3D56",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under heading — end",
      value: "#7CB5E6",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#7CB5E6",
    },
    {
      fieldName: "gradient_color_3",
      label: "Card border",
      value: "#E6E6E6",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#E6E6E6",
    },
    {
      fieldName: "gradient_color_4",
      label: "Prev/next button ring",
      value: "#D6D6D687",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#D6D6D687",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Portrait",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload portrait (222x213)",
      defaultValue: "",
    },
    {
      header: "Portrait alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Name",
      fieldName: "meta_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Designation",
      fieldName: "meta_designation",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
